import React, { useEffect, useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { ReactComponent as ArrowUpIcon } from '@assets/icons/arrow-up.svg';
import { Container } from '@components/GoTop/styled';
import { ViewModeWidth } from '@helpers/viewModeHelper';
import { FAVORITE_ONBOARD_KEY, generateTriggerClass } from '@utils/onboarding';

const GoTop = () => {
  const [positionY, setPositionY] = useState(window.scrollY);
  const isMinMD = useMediaQuery({
    minWidth: ViewModeWidth.MD,
  });

  const scrollDistance = useMemo(() => (isMinMD ? 150 : 100), [isMinMD]);

  const processEvent = () => {
    setPositionY(window.scrollY);
  };

  useEffect(() => {
    document.addEventListener('scroll', processEvent);

    return () => {
      document.removeEventListener('scroll', processEvent);
    };
  }, []);

  return (
    <Container
      onClick={() => window.scrollTo(0, 0)}
      className={generateTriggerClass(FAVORITE_ONBOARD_KEY, 1)}
      show={positionY >= scrollDistance}
    >
      <ArrowUpIcon />
    </Container>
  );
};

export default GoTop;
